import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EmployeesFormTrainingsForm } from '@modules/employees/EmployeesFormTrainingsForm';
import { trainingsGridColumns } from '@modules/employees/_employeesColumns';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Školení</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="trainings"
            Form={EmployeesFormTrainingsForm}
            columns={trainingsGridColumns}
            showCheckboxes={true}
            deleting={true}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormTrainings = View;



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormTrainings.tsx